import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { Card, Grid, Header, Tab } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import ProfileCard from './ProfileCard';

function ProfileFollowingsTaggle() {
    const usStore = useStore();

    // useEffect(() => { //' nn since we using reaction from mobx
    //     usStore.profileStore.loadFollowingsTaggle('following');
    // }, [usStore.profileStore.loadFollowingsTaggle])  

    return (
        <Tab.Pane loading={usStore.profileStore.isLoadingFollowings}>
            <Grid>
                <Grid.Column width='16' >
                    <Header 
                        content={usStore.profileStore.activeTabNumber === 3 ? `People following ${usStore.profileStore.profile?.displayName}` : `People ${usStore.profileStore.profile?.displayName} is following`  } 
                        icon='user' 
                        floated='left' 
                    />
                </Grid.Column>
                <Grid.Column width='16' >
                    <Card.Group itemsPerRow={4}>
                    {usStore.profileStore.followingProfiles && usStore.profileStore.followingProfiles.map(followingProfile => (
                        <ProfileCard profile={followingProfile} key={followingProfile.userName} />
                    ))}
                    </Card.Group>
                </Grid.Column>
            </Grid>
        </Tab.Pane>
    )
}

export default observer(ProfileFollowingsTaggle);